import React, { Component } from 'react'
import {Slider} from 'antd'
import ResourceItem from '../../models/resourceItem'
import ReactPlayer from 'react-player'
// img
import VideoStartIcon from '../../../../assets/image/chapter/videoStart.svg'
import VideoPauseIcon from '../../../../assets/image/chapter/videoPause.svg'
import VideoFullScreenIcon from '../../../../assets/image/chapter/videoFullScreen.svg'
import VideoVolumnIcon from '../../../../assets/image/chapter/videoVolumn.svg'
// model
import MediaExtradata from '../../../eventTracking/model/mediaExtradata'

interface iProps {
    extraProps: ResourceItem[],
    clazzId: string,
    spaceId: string,
    resourceType: string,
    eventTrackingReport?: (params: MediaExtradata) => void
}
interface iState {
    videoState: boolean,
    timeConsuming: number,
    playStartTime: number // 本次视频开始播放的时间
}
let videoplayer
let videoInterval = null // 观看视频定时器
export default class clazzVideo extends Component<iProps,iState> {
    state: iState = {
        videoState: false,
        timeConsuming:0,   // 本页耗时
        playStartTime: null
    }
    // 操作视频播放组件的对象
    ref = player => { videoplayer = player }
    playVideo = () => {
        this.setState({videoState: !this.state.videoState})
    }
    // 时间格式化
    formatTimeConsuming = val =>{
        const formateDate = parseInt(val,0) || this.state.timeConsuming
        if(formateDate>60){
            const m = Math.floor(formateDate/60)  // 分钟
            const s = formateDate - 60*m              // 秒 
            let res = ""
            if(m<10){res +=`0${m}:`}else{res +=`${m}:`}
            if(s<10){res +=`0${s}`}else{res +=`${s}`}
            return res
        }
        if(formateDate<10){
            return `00:0${formateDate}` 
        }
        return `00:${formateDate}`    
    }
    // 判断URL是否合法
    jugeUrl = (URL) => {
        var str = URL;
        //判断URL地址的正则表达式为:http(s)?://([\w-]+\.)+[\w-]+(/[\w- ./?%&=]*)?
        //下面的代码中应用了转义字符"\"输出一个字符"/"
        var Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
        var objExp = new RegExp(Expression);
        if (objExp.test(str) == true) {
            return true;
        } else {
            return false;
        }
    }
    componentDidMount () {
        // console.log(this.props)
        // let that= this;
        // (function(window, videojs) {
        //     console.log(videojs)
        //     if (!window['player']) {
        //         // @ts-ignore: Unreachable code error
        //         var player = window['player'] = ctyunplayer('ctyun-player');
        //         player.setUrl(that.props.extraProps[0]?.playUrl)
        //     } else {
        //         var player = window['player']
        //         player.setUrl(that.props.extraProps[0]?.playUrl)
        //     }
        //     // player.setFloatingComments(data);
        // }(window, window['videojs']));
        // (function(window){
        //     window['player'].onLoadStart(function(){
        //         console.log("onLoadStart：视频开始加载事件");
        //     });
        //     window['player'].onPlay(function(){
        //         console.log("onPlay：视频开始播放事件");
        //     });
        //     window['player'].onPlayMain(function(){
        //         console.log("onPlayMain：主视频开始播放事件");
        //     });
        //     window['player'].onStopMain(function(){
        //         console.log("onStopMain：主视频停止播放事件");
        //     });
        //     window['player'].onPause(function(){
        //         console.log("onPause：暂停播放事件");
        //     });
        //     window['player'].onSeekedTo(function(){
        //         console.log("onSeekedTo：进度条跳跃事件");
        //     });
        //     window['player'].onStop(function(){
        //         console.log("onStop：停止播放事件");
        //     });
        //     window['player'].onEnterFullScreen(function(){
        //         console.log("onEnterFullScreen：进入全屏事件");
        //     });
        //     window['player'].onExitFullScreen(function(){
        //         console.log("onExitFullScreen：退出全屏事件");
        //     });
        //     window['player'].onError(function(){
        //         console.log("onError：发生错误事件");
        //     });
        // })(window);
        if (this.props.resourceType && this.props.resourceType === 'LINK') {
            if (this.jugeUrl(this.props.extraProps[0].playUrl)) {
                window.open(this.props.extraProps[0].playUrl, '_blank')
            }
        }
    }
    componentWillUnmount () {
        // window['player'].dispose();
        videoInterval && clearInterval(videoInterval)
    }
    vieoProgressCallback = (params) => {
        console.log(params)
    }
    // 视频开始播放
    videoPlay = () => {
        console.log('视频开始播放')
        let that = this
        let {extraProps, clazzId, spaceId} = this.props
        this.setState({playStartTime: (+new Date())})
        videoInterval = setInterval(() => {
            that.props.eventTrackingReport(
                new MediaExtradata({
                    container_id: spaceId, 
                    class_id: clazzId, resource_id: 
                    extraProps[0]?.id,
                    watch_at: this.state.playStartTime, 
                    look_time: 10
                })
            )
        }, 10000)
    }
    // 视频开始播放
    videoPause = () => {
        console.log('视频暂停播放')
        videoInterval && clearInterval(videoInterval)
    }
    // 阻止视频右键点击下载
    onContextMenu(e){
        e.preventDefault()
        // alert("右单击")
    }
    render() {
        let {extraProps, resourceType} = this.props
        let {videoState} = this.state
        return (
            <div className='clazzVideo player-wrapper' onContextMenu={this.onContextMenu.bind(this)}>
                {resourceType === 'VIDEO' &&
                    ((extraProps && !!(extraProps.length) && extraProps[0].playUrl) ? 
                    <ReactPlayer
                        ref={this.ref}
                        className='react-player' 
                        url={extraProps[0]?.playUrl}
                        controls={true}
                        onContextMenu={(e) => e.preventDefault()}
                        config={{
                          file: { attributes: { controlsList: "nodownload noplaybackrate" ,disablePictureInPicture: true} },
                        }}
                        // progressInterval={100}
                        playing={videoState}
                        width='96%'
                        height='100%'
                        onPlay={this.videoPlay}
                        onPause={this.videoPause}
                    />:
                    <div style={{fontSize: 18, color: 'rgba(0,0,0,.85)', fontWeight: 'bold'}}>本课时未上传视频</div>)
                }
                {resourceType === 'LINK' && this.props.extraProps[0] &&
                <div style={{fontSize: 18, color: 'rgba(0,0,0,.85)', fontWeight: 'bold'}}>
                    {this.jugeUrl(this.props.extraProps[0].playUrl) ? '通过外链形式打开' : '链接不合法'}
                </div>}
            </div>
        )
    }
}

